import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=4cb418d7&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=4cb418d7&lang=scss&scoped=true&"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=4cb418d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb418d7",
  null
  
)

export default component.exports